<template>
  <div class="body">
    <div class="Top">
      <img class="top"
        src="../../assets/oldManBill/top.png"
        alt="" />
      <div class="first">专业运营团队</div>
      <div>打造高品质养老服务</div>
      <div class="img">
        <img class="second"
          src="../../assets/oldManBill/second.png"
          style="position: relative">
        <div class="text">打造专业“医养护康"特色养老机构</div>

      </div>
    </div>
    <div class="title">
      融辉城养老服务中心
      <img src="../../assets/oldManBill/title.png"
        alt=""
        style="width: 4.45rem; margin-top: 0.18rem" />
    </div>
    <div class="content">
      <div class="tit1">融辉城养老服务中心简介</div>
      <div class="con">
        融辉城养老服务中心是融辉城社区卫生服务中心托
        管机构，位于周口市商水县融辉城社区阳城第一山
        内。养老服务中心引进专业老年人护理理念，将养
        老、护理、医疗、康复相结合，打造具备专业“医
        养护康"条件的特色养老机构。内部环境优美、设
        施齐全，构成了集养老、医疗、办公、学习、保健、
        娱乐、休息于一体的综合配套服务体系。
      </div>
      <div class="yldy">养老单元</div>
      <div class="con">使用面积2000余平方米，现开设床位20余张</div>
      <div class="yldy">生活资源</div>
      <div class="con">区域交通路网规划发达，周边配套规划丰富。</div>
    </div>
    <!--  -->
    <div class="title"
      style="color: #ff9248">活力养老 安享晚年</div>
    <div class="des">丰富多样的娱乐活动，让老人有陪伴，有快乐</div>
    <div class="imgs">
      <img src="../../assets/oldManBill/imgs1.png"
        alt="" />
      <img src="../../assets/oldManBill/imgs2.png"
        alt="" />
      <img src="../../assets/oldManBill/imgs3.png"
        alt="" />
      <img src="../../assets/oldManBill/imgs4.png"
        alt="" />
    </div>
    <div class="content con"
      style="margin: 0; font-size: 0.14rem">
      内部环境优美、设施齐全，构成了集养老、医疗、办公、学习、保健、娱乐、休息于一体的综合配套服务体系。
    </div>
    <div class="imgs">
      <img src="../../assets/oldManBill/imgs5.png"
        alt="" />
      <img src="../../assets/oldManBill/imgs6.png"
        alt="" />
    </div>
    <div class="content con"
      style="margin: 0; font-size: 0.14rem">
      按生活区、娱乐区、康复区、学习区、餐饮区，生活区内空调、呼叫器、衣柜、无线网络、电视、二十四小时热水卫浴等生活设施一应俱全，为老人提供日常保健和个性化生活照护的养老模式。
    </div>
    <div class="imgs">
      <img src="../../assets/oldManBill/imgs7.png"
        alt="" />
      <img src="../../assets/oldManBill/imgs8.png"
        alt="" />
    </div>
    <div class="content con"
      style="margin: 0; font-size: 0.14rem">
      内部设有阅览室、棋牌娱乐室等文化加乐区域。有专人定时定点组织院内老人做与学习舞蹈、各种娱乐活动以及来自社会各界志愿者们不定期的拜访，让在院老人的晚年生活变得多姿多彩。
    </div>
    <!--  -->
    <div class="title"
      style="color: #ff9248">贴心餐饮 美味可口</div>
    <div class="imgs">
      <img src="../../assets/oldManBill/imgs9.png"
        alt="" />
      <img src="../../assets/oldManBill/imgs10.png"
        alt="" />
    </div>
    <div class="content con"
      style="margin: 0; font-size: 0.14rem">
      每日三餐由专业餐饮团队合力配餐，并提供新鲜水果、美味糕点的下午茶
    </div>
    <div class="imgs">
      <img src="../../assets/oldManBill/imgs11.png"
        alt="" />
      <img src="../../assets/oldManBill/imgs12.png"
        alt="" />
    </div>
    <div class="content con"
      style="margin: 0; font-size: 0.14rem">
      聘请专业厨师定制适老化菜品，餐点以口感适老、营养均衡、美味可口为基础
    </div>
    <div class="imgs"
      style="padding: 0.2rem 0.44rem;">
      <img src="../../assets/oldManBill/imgs13.png"
        alt=""
        style="width: 5.496rem; height: 2.504rem; " />
    </div>
    <div class="content con"
      style="margin: 0; font-size: 0.14rem">
      现开设床位20余张，可接待自理老人、半失智老人、全失能老人、半失能老人、全失智老人。
    </div>
    <!--  -->
    <div class="title"
      style="color: #ff9248">室内外适老化设计</div>
    <div class="des"
      style="font-size: 0.16rem">让老人住的安全舒心</div>
    <div class="imgs">
      <img src="../../assets/oldManBill/imgs14.png"
        alt="" />
      <img src="../../assets/oldManBill/imgs15.png"
        alt="" />
    </div>
    <div class="content con"
      style="margin: 0; font-size: 0.14rem; margin-bottom: 0.385rem">
      社区严格落实门禁管理、访客登记、视频监控及24小时保安执勤，室内外配备无障碍设施，智能求助等为老人人身财产安全保驾护航。
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    };
  },
  mounted () {
    ; (function (doc, win) {
      var docEl = doc.documentElement,
        resizeEvt =
          'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {
          var clientWidth = docEl.clientWidth
          if (!clientWidth) return
          if (clientWidth >= 640) {
            docEl.style.fontSize = '100px'
          } else {
            docEl.style.fontSize = 100 * (clientWidth / 640) + 'px'
          }
        }
      if (!doc.addEventListener) return
      win.addEventListener(resizeEvt, recalc, false)
      doc.addEventListener('DOMContentLoaded', recalc, false)
    })(document, window)
  },
  methods: {
  }
}
</script>
<style scoped>
@font-face {
  font-family: 'FZYaSong-B-GBK';
  src: url('../../assets/oldManBill/方正粗雅宋_GBK.TTF');
}
.body {
  margin: 0;
  background-color: #fffefd;
}

.Top {
  height: 8.236rem;
  overflow: hidden;
}

.top {
  position: absolute;
  width: 6.4rem;
}

.Top div {
  font-size: 0.33rem;
  font-family: 'FZYaSong-B-GBK';
  font-weight: 400;
  color: #be1a3e;
  text-align: center;
}

.first {
  margin-top: 0.65rem;
}

.img {
  margin-top: 0.09rem;
}

.second {
  margin: auto;
  width: 2.61rem;
}

.Top .text {
  position: relative;
  top: -0.32rem;
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #be1a3e;
}

.title {
  text-align: center;
  font-size: 0.28rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fe9249;
  margin-top: 0.53rem;
}

.content {
  margin-top: 0.285rem;
  box-sizing: border-box;
  padding: 0 0.14rem 0 0.255rem;
}

.tit1 {
  font-size: 0.17rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ff9248;
}

.con {
  margin-top: 0.175rem;
  font-size: 0.15rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}

.yldy {
  margin-top: 0.35rem;
  width: 0.87rem;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  background: linear-gradient(to right, #fffefd, #fee4d4);
  border-radius: 0.15rem;
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff9248;
}

.des {
  text-align: center;
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff9248;
}

.imgs {
  box-sizing: border-box;
  padding: 0.2rem 0.6rem 0.155rem 0.6rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.imgs img {
  width: 2.1645rem;
  height: 1.508rem;
  margin-bottom: 0.095rem;
}
</style>